module.exports = "<div *ngIf=\"profile$ | async as profile\">\n    <span class=\"greetings\">Hi {{ profile.first_name }}</span>\n</div>";